/**
 * PixiSetup — Initialize PixiJS v8 Application.
 * Uses async Application.init() as required by v8 API.
 */
import { Application } from 'pixi.js';

let app = null;

/**
 * Create and initialize the PixiJS application.
 * Mounts the canvas into the #game-canvas container.
 * @returns {Promise<Application>}
 */
export async function initPixiApp() {
  app = new Application();

  const container = document.getElementById('game-canvas');

  await app.init({
    background: 0x0a0a14,
    resizeTo: container,
    antialias: false,
    resolution: window.devicePixelRatio || 1,
    autoDensity: true,
  });

  // Mount canvas
  container.appendChild(app.canvas);

  // ResizeObserver for responsive canvas
  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      const { width, height } = entry.contentRect;
      app.renderer.resize(width, height);
      // Emit resize event for scenes
      if (window.__debug && window.__debug._onResize) {
        window.__debug._onResize(width, height);
      }
    }
  });
  resizeObserver.observe(container);

  return app;
}

/**
 * Get the PixiJS application instance.
 * @returns {Application|null}
 */
export function getApp() {
  return app;
}
